var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlocked(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10Z",
    fill: "#F24F63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9321 3.93243C8.34094 3.93243 6.81495 4.56452 5.68983 5.68964C4.5647 6.81477 3.93262 8.34076 3.93262 9.93192C3.93262 11.5231 4.5647 13.0491 5.68983 14.1742C6.81495 15.2993 8.34094 15.9314 9.9321 15.9314C11.5233 15.9314 13.0493 15.2993 14.1744 14.1742C15.2995 13.0491 15.9316 11.5231 15.9316 9.93192C15.9316 8.34076 15.2995 6.81477 14.1744 5.68964C13.0493 4.56452 11.5233 3.93243 9.9321 3.93243ZM6.75049 6.7503C7.5943 5.90649 8.73877 5.43243 9.9321 5.43243C10.7884 5.43243 11.6196 5.67654 12.3326 6.12623L6.53832 12.8862C5.82762 12.0698 5.43262 11.0212 5.43262 9.93192C5.43262 8.73858 5.90667 7.59412 6.75049 6.7503ZM7.6983 13.8378C8.37268 14.2234 9.14167 14.4314 9.9321 14.4314C11.1254 14.4314 12.2699 13.9574 13.1137 13.1135C13.9575 12.2697 14.4316 11.1253 14.4316 9.93192C14.4316 8.90795 14.0826 7.91996 13.4504 7.12703L7.6983 13.8378Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.69a58f64.svg";
export { ForwardRef as ReactComponent };